import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { SortType } from "../carLine/carLineApi";

export interface ITypeVehicle {
  id: number
  code: string
  title: string
  carLineId: number
  carLineTitle: string
}

export interface ITypeVehicleEdit {
  id: number
  title: string
  categoryCarId: number
  carLinesId: number
}
export interface ITypeVehicleEditV2 {
  id: number
  title: string
  code: string
}

export interface IDataError {
  row: {
    titleCarLines: string
    titleTypeVehicle: any
    titleCategoryCar: string
    titleVehicleGroup: string
    titleVehicleModel: string
    titleCar: string
    code: string
    titleSegmentsVehicle: any
    codeB7: string
    codeCustomer?: string
    dateReception?: string
    typeSupport?: string
    note?: string
    adminName?: string
    supportChanel?: string
    sourceCustomer?: string
  }
  reason: string
  rowIndex: number
}

export interface ResponseSuccessDataError {
  status: boolean;
  dataError: IDataError[];
  message: string;
  newlyCreatedRecords: number
  totalRecords: number
  unimportedRecords: number
}

// import thương hiệu xe
export const uploadFileCategoryCar = async (
  file: File,
) => {
  const url = `categoryCar/importExcel`;
  const params = {
    file
  }
  const result: ResponseSuccessDataError = await axiosClient.post(
    url, params
  );
  return result;
}


// import dòng xe
export const uploadFileCarLines = async (
  file: File,
) => {
  const url = `carLines/importExcel`;
  const params = {
    file
  }
  const result: ResponseSuccessDataError = await axiosClient.post(
    url, params
  );
  return result;
}

// import loại xe
export const uploadFileTypeVehicle = async (
  file: File,
) => {
  const url = `typeVehicle/importExcel`;
  const params = {
    file
  }
  const result: ResponseSuccessDataError = await axiosClient.post(
    url, params
  );
  return result;
}


export const getListTypeVehicle = async (
  limit?: number, pageNumber?: number, carLineId?: number, searchNameTypeVehicle?: string) => {
  const path = "typeVehicle/listTypeVehicle"
  const params = {
    limit, pageNumber, carLineId, searchNameTypeVehicle
  }
  const result: ResponseSuccessTotal<ITypeVehicle[]> = await axiosClient.get(
    path, { params: paserParams(params, undefined) }
  );
  return result;
};

//Thông tin loại xe
export const getInfoTypeVehicle = async (
  id: number) => {
  const path = "typeVehicle/infoTypeVehicle"
  const params = {
    id
  }
  const result: ResponseSuccess<ITypeVehicle> = await axiosClient.get(
    path, { params }
  );
  return result;
};
export const getInfoTypeVehicleV2 = async (
  id: number) => {
  const path = "typeVehicle/infoTypeVehicle"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<ITypeVehicleEditV2> = await axiosClient.get(
    path, { params }
  );
  return result;
};
//Thêm mới loại xe
export const addTypeVehicle = async (
  title: string, code: string, idCarLine: number
) => {
  const url = `typeVehicle/addTypeVehicle`;
  const params = {
    title, code, idCarLine
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

//Chỉnh sửa loại xe
export const editTypeVehicle = async (
  id: number, title: string, code: string, idCarLine: number
) => {
  const url = `typeVehicle/editTypeVehicle`;
  const params = {
    id, code, title, idCarLine
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

//Xóa loại xe
export const deleteTypeVehicle = async (
  id: number
) => {
  const url = `typeVehicle/deleteTypeVehicle`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}

export const updateActiveTypeVehicle = async (
  id: number) => {
  const path = "typeVehicle/activeTypeVehicle"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};
